import React, { useCallback, useEffect, useState } from "react";
import { SvgImages } from "../../../Utils/LocalImages";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../../Components/Reusable/ButtonWithIcon";
import CustomDropDown from "../../../Components/Reusable/CustomDropDown";
import * as yup from "yup";
import {
  InputType,
  getTextFromHtml,
  handleApiErrors,
  validationRegex,
} from "../../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ClassService from "../../../Services/ClassService";
import DataProvider from "../../../Utils/DataProvider";
import SubjectService from "../../../Services/SubjectService";
import Image from "../../../Components/Reusable/Image";
import RoutesPath from "../../../Utils/RoutesPath";
import { ConfirmationModalTheme, ImageFilters } from "../../../Utils/Enums";
import CustomTextField from "../../../Components/Reusable/CustomTextField";
import BharatSatService from "../../../Services/BharatSatService";
import moment from "moment/moment";

const AddBharatSetExam = () => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [resetSubject, setResetSubject] = useState(false);
  const [resetMedium, setResetMedium] = useState(false);
  const [bharatSatExam, setbharatSatExam] = useState({
    ...useLocation().state,
  });
  const [negativeMarking, setNegativeMarking] = useState(bharatSatExam.negativeMarking==="No" ? false : true);
  const [deleteInput, setDeleteInput] = useState(false);
  const [additionalInputs, setAdditionalInputs] = useState([
    {
      name: "subject0",
      value: "numberOfQuestionsBank0",
      bharatSatValue: "numberOfQuestionsBharatSat0",
    },
  ]);
 

  const navigate = useNavigate();


  const stepOneValidations = yup.object().shape({
    bharatSatExamName: validationRegex.required,
    class_id: validationRegex.required,
    medium: validationRegex.required,
    durationInMinutes: yup
      .number()
      .typeError("Duration in minutes must be a number")
      .required("Field can't be empty!")
      .positive("Duration must be a positive number")
      .integer("Duration must be a whole number"),
    bharatSatExamDate: yup
      .date()
      .typeError("Please select a valid date")
      .required("Exam date is required")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)), // Current date with time set to 00:00:00
        "Exam date cannot be in the past"
      ),
    generateHallTicketDate: yup
      .date()
      .typeError("Please select a valid date")
      .required("Generate Hall Ticket date is required")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)), // Current date with time set to 00:00:00
        "Generate Hall Ticket date cannot be in the past"
      )
      .test(
        "is-before-exam-date",
        "Generate Hall Ticket date must be before the Bharat SAT Exam date",
        function (value) {
          const { bharatSatExamDate } = this.parent;
          if (bharatSatExamDate && value) {
            return value <= bharatSatExamDate; // Ensure Generate Hall Ticket Date is before Exam Date
          }
          return true; // If Exam Date is missing, skip the validation
        }
      ),
    examStartTime: yup.string().required("Start Time is required"), // Validate that Start Time is provided
    examEndTime: yup
      .string()
      .required("End Time is required") // Validate that End Time is provided
      .test(
        "is-after-start-time",
        "End Time must be after Start Time",
        function (value) {
          const { examStartTime } = this.parent;
          if (examStartTime && value) {
            return value > examStartTime; // Ensure End Time is after Start Time
          }
          return true; // If Start Time is missing, skip the validation
        }
      ),
  });

  const {
    register: registerStepOne,
    handleSubmit: handleSubmitStepOne,
    setValue: setValuesStepOne,
    formState: { errors: errorsStepOne },
    watch: watchStepOne,
    getValues: getValuesStepOne,
    reset: resetStepOne,
  } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      bharatSatExamName: bharatSatExam?.bharatSatExamName || "",
      class_id: bharatSatExam?.class_id || "",
      medium: bharatSatExam?.medium || "",
      durationInMinutes: bharatSatExam?.durationInMinutes || "",
      bharatSatExamDate: bharatSatExam?.bharatSatExamDate || "",
      generateHallTicketDate: bharatSatExam?.generateHallTicketDate || "",
      examStartTime: bharatSatExam?.examStartTime || '',
      examEndTime: bharatSatExam?.examEndTime || '',
      negativeMarking: bharatSatExam?.negativeMarking || false,
    },
  });

  const [stepTwoValidations, setStepTwoValidations] = useState(
    yup.object().shape({
      subject0: validationRegex.required,
      numberOfQuestionsBank0: yup
        .number()
        .typeError("Number of questions must be a number")
        .required("Field can't be empty!")
        .min(0, "Number of questions from the question bank must be 0 or greater") // Allow 0 but not negative values
        .notOneOf([-1], "Number of questions must be Positive"), // Exclude -1
      numberOfQuestionsBharatSat0: yup
        .number()
        .typeError("Number of questions must be a number")
        .required("Field can't be empty!")
        .min(0, "Number of questions from Bharat Sat exam must be 0 or greater") // Allow 0 but not negative values
        .notOneOf([-1], "Number of questions must be Positive"), // Exclude -1
    })
  );
  const defaultValues = {
    subject0: bharatSatExam ? bharatSatExam.subjectId : "",
    numberOfQuestionsBank0: bharatSatExam
      ? bharatSatExam.numberOfQuestionsBank
      : "",
    numberOfQuestionsBharatSat0: bharatSatExam
      ? bharatSatExam.numberOfQuestionsBharatSat
      : "",
  };

  // Use the dynamic schema in useForm
  const {
    register: registerStepTwo,
    handleSubmit: handleSubmitStepTwo,
    setValue: setValuesStepTwo,
    formState: { errors: errorsStepTwo },
    watch: watchStepTwo,
    getValues: getValuesStepTwo,
    reset: resetStepTwo,
  } = useForm({
    resolver: yupResolver(stepTwoValidations),
    defaultValues: defaultValues,
  });

  const saveStepOneData = (data) => {
    var updatedData = { ...bharatSatExam };
    updatedData.class_id = data.class_id;
    updatedData.className =
      classes?.find((e) => e._id === data.class_id)?.class_name ||
      updatedData.className;
    updatedData.bharatSatExamName = data.bharatSatExamName;
    updatedData.durationInMinutes = data.durationInMinutes;
    updatedData.bharatSatExamDate = data.bharatSatExamDate;
    updatedData.generateHallTicketDate = data.generateHallTicketDate;
    updatedData.examStartTime = data.examStartTime;
    updatedData.examEndTime = data.examEndTime;
    updatedData.medium = data.medium;
    setbharatSatExam(updatedData);
    if (bharatSatExam?.class_id == data.class_id) {
      getAllSubjects(data.class_id);
    }
    setCurrentStep(2);
  };
  const savestepTwoData = (data) => {
    addBharatSatExam(data);
  };

  const addBharatSatExam = async (data) => {
    try {
      let newData = { ...bharatSatExam };
      const response1 = await SubjectService.getAllSubjectsWithoutPagination(
        bharatSatExam.class_id
      );

      if (
        !response1 ||
        !Array.isArray(response1.data) ||
        response1.data.length === 0
      ) {
        throw new Error("No subjects found.");
      }

      const subjectCounts = response1.data.reduce((acc, subject) => {
        if (subject._id) {
          acc[subject._id] = {
            questionCount: subject.questionCount || 0,
            questionBankCount: subject.questionBankCount || 0,
            bharatSatQuestionCount: subject.bharatSatQuestionCount || 0,
          };
        }
        return acc;
      }, {});

      let subjectData = [];
      let hasError = false;

      additionalInputs.forEach((item) => {
        const subject = getValuesStepTwo(item.name);
        const numberOfQuestionsBank = parseInt(
          getValuesStepTwo(item.value),
          10
        );
        const numberOfQuestionsBharatSat = parseInt(
          getValuesStepTwo(item.bharatSatValue),
          10
        );

        const subjectInfo = subjectCounts[subject];
        if (!subjectInfo) {
          toast.error("Subject not found.");
          hasError = true;
          return;
        }

        // Validate against available counts
        if (numberOfQuestionsBank > subjectInfo.questionBankCount) {
          toast.error(
            `The number of questions from Question Bank exceeds available questions (${subjectInfo.questionBankCount}).`
          );
          hasError = true;
          return;
        }

        if (numberOfQuestionsBharatSat > subjectInfo.bharatSatQuestionCount) {
          toast.error(
            `The number of questions from SAT Exam exceeds available questions (${subjectInfo.bharatSatQuestionCount}).`
          );
          hasError = true;
          return;
        }


        subjectData.push({
          subjectId: subject,
          numberOfQuestionsBank,
          numberOfQuestionsBharatSat,
        });
      });

      if (hasError) {
        return;
      }
      const formatDate = (date) => {
        const year = new Date(date).getFullYear();
        const month = String(new Date(date).getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(new Date(date).getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`; // Return in yyyy/mm/dd format
      };

      newData.subjectData = subjectData;
      const bharatSatExamDateIST = formatDate(bharatSatExam.bharatSatExamDate);
      const generateHallTicketDateIST = formatDate(bharatSatExam.generateHallTicketDate);
      const examStartTime = moment(`${bharatSatExamDateIST} ${bharatSatExam.examStartTime}`, "YYYY-MM-DD HH:mm").utc().format();
      const examEndTime = moment(`${bharatSatExamDateIST} ${bharatSatExam.examEndTime}`, "YYYY-MM-DD HH:mm").utc().format();

      const response = await BharatSatService.CreateBharatsatExam(
        bharatSatExam.bharatSatExamId || "",
        bharatSatExam.bharatSatExamName,
        bharatSatExamDateIST,
        examStartTime,
        examEndTime,
        bharatSatExam.medium,
        bharatSatExam.class_id,
        bharatSatExam.durationInMinutes,
        newData.subjectData,
        generateHallTicketDateIST,
      negativeMarking === true ? "Yes" : "No"

      );

      if (response) {
        newData = { ...newData, bharatSatExamId: response.bharatSatExamId };
        setbharatSatExam(newData);
        setCurrentStep(3);
        toast.success(bharatSatExam.bharatSatExamId ? "Exam updated successfully!" : "Exam created successfully!");
      }
    } catch (error) {
      console.error("Error in addBharatSatExam:", error);
      toast.error(error.message || "An error occurred while saving the exam.");
    }
  };

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllSubjects = async (classId) => {
    try {
      const response = await SubjectService.getAllSubjectsWithoutPagination(
        classId
      );
      setSubjects(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };


  useEffect(() => {
    getAllClasses();
    if (bharatSatExam && bharatSatExam.subjectData) {
      const subjectInputs = [];
      bharatSatExam.subjectData.forEach((data, index) => {
        addValidation(`subject${index}`, validationRegex.required);
        addValidation(
          `numberOfQuestionsBank${index}`,
          yup
            .number()
            .typeError("Number of questions must be a number")
            .required("Field can't be empty!")
            .min(0, "Number of questions from the question bank must be 0 or greater") // Allow 0 but not negative values
            .notOneOf([-1], "Number of questions must be Positive"),
        );
        addValidation(
          `numberOfQuestionsBharatSat${index}`,
          yup
            .number()
            .typeError("Number of questions must be a number")
            .required("Field can't be empty!")
            .min(0, "Number of questions from the question bank must be 0 or greater") // Allow 0 but not negative values
            .notOneOf([-1], "Number of questions must be Positive"),
        );
        subjectInputs.push({
          name: `subject${index}`,
          value: `numberOfQuestionsBank${index}`,
          bharatSatValue: `numberOfQuestionsBharatSat${index}`,
        });

        setValuesStepTwo(`subject${index}`, data.subject?._id || data.subjectId);
        setValuesStepTwo(
          `numberOfQuestionsBank${index}`,
          data?.numberOfQuestionsBank
        );
        setValuesStepTwo(
          `numberOfQuestionsBharatSat${index}`,
          data?.numberOfQuestionsBharatSat
        );
      });
      setAdditionalInputs(subjectInputs);
    }

  }, []);

  const addValidation = useCallback((fieldName, validationSchema) => {
    setStepTwoValidations((prevSchema) =>
      prevSchema.shape({ [fieldName]: validationSchema })
    );
  }, []);

  // Handler to remove validation dynamically
  const removeValidation = useCallback((fieldName) => {
    setStepTwoValidations((prevSchema) => {
      const { [fieldName]: _, ...rest } = prevSchema.fields; // Remove the specific field
      return yup.object().shape(rest);
    });
  }, []);

  const handleAddMore = () => {
    const newIndex = additionalInputs.length;
    addValidation(`subject${newIndex}`, validationRegex.required);
    addValidation(`numberOfQuestionsBank${newIndex}`, yup
      .number()
      .typeError("Number of questions must be a number")
      .required("Field can't be empty!")
      .min(0, "Number of questions from the question bank must be 0 or greater") // Allow 0 but not negative values
      .notOneOf([-1], "Number of questions must be Positive"),
    );
    addValidation(
      `numberOfQuestionsBharatSat${newIndex}`,
      yup
        .number()
        .typeError("Number of questions must be a number")
        .required("Field can't be empty!")
        .min(0, "Number of questions from the question bank must be 0 or greater") // Allow 0 but not negative values
        .notOneOf([-1], "Number of questions must be Positive"),
    );
    // Add a new input field with a unique index
    setAdditionalInputs([
      ...additionalInputs,
      {
        name: `subject${newIndex}`,
        value: `numberOfQuestionsBank${newIndex}`,
        bharatSatValue: `numberOfQuestionsBharatSat${newIndex}`,
      },
    ]);
    // Reset the mock test dropdown and attempts field for the new entry
    setValuesStepTwo(`subject${newIndex}`, "");
    setValuesStepTwo(`numberOfQuestionsBank${newIndex}`, "");
    setValuesStepTwo(`numberOfQuestionsBharatSat${newIndex}`, "");
    setDeleteInput(true);
  };
  const handleDelete = (index) => {
    // Remove the validation for the field being deleted
    removeValidation(additionalInputs[index].name);
    removeValidation(additionalInputs[index].value);
    removeValidation(additionalInputs[index].bharatSatValue);
    // Remove the input field
    const newInputs = [...additionalInputs];
    newInputs.splice(index, 1);
    // Update the state with the remaining input fields
    setAdditionalInputs(newInputs);
    // Reset the delete input button state
    if (newInputs.length === 1) {
      setDeleteInput(false);
    }
  };
  useEffect(() => {

    // Parse the date from the format "DD-MM-YYYY"
    const parseDate = (dateString) => {
      if (typeof dateString !== 'string') return null; // Ensure dateString is a string
      const [day, month, year] = dateString.split("-");
      return new Date(`${year}-${month}-${day}`); // Convert to "YYYY-MM-DD" format
    };


    if (bharatSatExam) {
      const bharatSatExamDate = parseDate(bharatSatExam.bharatSatExamDate);
      const generateHallTicketDate = parseDate(bharatSatExam.generateHallTicketDate);

      // Check if bharatSatExamDate is a valid date
      if (bharatSatExamDate && !isNaN(bharatSatExamDate.getTime())) {
        setValuesStepOne("bharatSatExamDate", bharatSatExamDate.toLocaleDateString("sv-SE") || "");
      }
      // Check if generateHallTicketDate is a valid date
      if (generateHallTicketDate && !isNaN(generateHallTicketDate.getTime())) {
        setValuesStepOne("generateHallTicketDate", generateHallTicketDate.toLocaleDateString("sv-SE") || "");
      }
    }
  }, [bharatSatExam, setValuesStepOne]);



  useEffect(() => {
    const parseTime = (time) => {
      if (!time) return ""; // Handle empty or undefined time
      // Use Moment.js to format the time in 12-hour format with AM/PM
      return moment(time).format('HH:mm'); // Use 'HH:mm' for 24-hour format, or 'hh:mm A' for 12-hour format
    };

    if (bharatSatExam) {
      // Convert and set the times in the form using Moment.js
      const examStartTime = parseTime(bharatSatExam.examStartTime);
      const examEndTime = parseTime(bharatSatExam.examEndTime);
      setValuesStepOne("examStartTime", examStartTime);
      setValuesStepOne("examEndTime", examEndTime);
    }
  }, [bharatSatExam, setValuesStepOne]);


  useEffect(() => {
    const examEndTime = getValuesStepOne("examEndTime")
    const examStartTime = getValuesStepOne("examStartTime")
    calculateDuration(examStartTime, examEndTime)
  }, [watchStepOne("examEndTime", "examStartTime")])

  const calculateDuration = (examStartTime, examEndTime) => {
    if (examStartTime || examEndTime) {
      const startTime = moment(examStartTime, "HH:mm"); //convert 12 hours time to 24 hours
      const endTime = moment(examEndTime, "HH:mm"); //convert 12 hours time to 24 hours
      const duration = moment.duration(endTime.diff(startTime)); //get the difference between start and end time

      if (duration.asMinutes() > 0) {
        setValuesStepOne("durationInMinutes", duration.asMinutes());
      } else {
        console.log("Invailed Start and End time");
      }
    }
  };



  return (
    <div className="content" data-number="1">
      <div className="mb-3 d-flex justify-content-between">
        <h1 className="black fs-18 fw-600 mb-0">BHARAT SAT</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Bharat SAT</h4>
        </div>
      </div>

      <div className="table_container">
        <div className="table_title p-0">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {bharatSatExam?.bharatSatExamId ? "Edit Bharat SAT Exam" : "Create Bharat SAT Exam"}
            </h1>
          </div>
        </div>

        <div className="progress_bar">
          <div
            className={`step-${currentStep === 2.1 ? 2 : currentStep}`}
            id="checkout-progress"
            data-current-step="1"
          >
            <div className="progress-bar">
              <div
                onClick={() => {
               
                  setValuesStepOne("examStartTime",bharatSatExam?.examStartTime);
                  setValuesStepOne("examEndTime",bharatSatExam?.examEndTime);
                  setCurrentStep(1)
                }}
                className={`step cursor-pointer step-1 ${currentStep === 1 ? "active" : currentStep > 1 ? "valid" : ""
                  }`}
              >
                <span> 01</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
              <div
                onClick={() => {
                  if (currentStep > 2) setCurrentStep(2);
                }}
                className={`step cursor-pointer step-2 ${currentStep === 2 || currentStep === 2.1
                  ? "active"
                  : currentStep > 2 || currentStep > 2.1
                    ? "valid"
                    : ""
                  }`}
              >
                <span> 02</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
              <div
                className={`step cursor-pointer step-3 ${currentStep === 3 ? "active" : currentStep > 3 ? "valid" : ""
                  }`}
              >
                <span> 03</span>
                <div className="fa fa-check opaque">
                  <Image src={SvgImages.tick_mark}></Image>
                </div>
              </div>
            </div>
          </div>
        </div>

        {currentStep === 1 ? (
          <form onSubmit={handleSubmitStepOne(saveStepOneData)}>
            <div className="row profile_inputs w-100">
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Bharat SAT Exam Name"
                  placeholder="Bharat SAT Exam Name"
                  name="bharatSatExamName"
                  id="bharatSatExamName"
                  showError={errorsStepOne?.bharatSatExamName}
                  errorMessage={errorsStepOne?.bharatSatExamName?.message}
                  register={registerStepOne}
                  additionalClasses="profile_edit"
                  showMandatory={true}
                  setValue={setValuesStepOne}
                />
              </div>
              <div className="col-md-6">
                <CustomDropDown
                  labelTitle="Select Medium"
                  placeholder="Select Medium"
                  name="medium"
                  id="medium"
                  additionalClasses="profile_edit"
                  setResetValue={setResetMedium}
                  resetValue={resetMedium}
                  inputType={InputType.text}
                  showError={errorsStepOne?.medium}
                  errorMessage={errorsStepOne?.medium?.message}
                  showMandatory={true}
                  setValue={setValuesStepOne}
                  options={DataProvider.mediumList}
                  defaultOption={() => {
                    return bharatSatExam.medium
                      ? {
                        value: bharatSatExam.medium,
                        label: bharatSatExam.medium,
                      }
                      : null;
                  }}
                />
              </div>
              <div className="col-md-6">
                <CustomDropDown
                  labelTitle="Select Class"
                  placeholder="Select"
                  name="class_id"
                  id="class_id"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showError={errorsStepOne?.class_id}
                  errorMessage={errorsStepOne?.class_id?.message}
                  showMandatory={true}
                  setValue={setValuesStepOne}
                  onChange={(e) => {
                    getAllSubjects(e.value)
                    resetStepTwo();
                    setResetSubject(true)
                  }}
                  options={
                    classes?.map((e) => { return { value: e._id, label: e.class_name } })
                  }
                  defaultOption={() => {
                    return (bharatSatExam.class_id && bharatSatExam.className) ? { value: bharatSatExam.class_id, label: bharatSatExam.className } : null
                  }}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Bharat SAT Examination Date"
                  placeholder="Enter date"
                  name="bharatSatExamDate"
                  id="bharatSatExamDate"
                  showError={errorsStepOne?.bharatSatExamDate}
                  errorMessage={errorsStepOne?.bharatSatExamDate?.message}
                  register={registerStepOne}
                  additionalClasses="profile_edit"
                  inputType="date"
                  showMandatory={true}
                  setValue={setValuesStepOne}

                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Generate Hall Ticket Date"
                  placeholder="Enter date"
                  name="generateHallTicketDate"
                  id="generateHallTicketDate"
                  showError={errorsStepOne?.generateHallTicketDate}
                  errorMessage={errorsStepOne?.generateHallTicketDate?.message}
                  register={registerStepOne}
                  additionalClasses="profile_edit"
                  inputType="date"
                  showMandatory={true}
                  setValue={setValuesStepOne}

                />
              </div>
              <div className="col-md-6">

                <div className="col-md-12 d-flex align-items-center">
                  {/* Start Time Field */}
                  <div className="col-md-6">
                    <div className="d-flex justify-content-between">
                      <label htmlFor="startTime" className="login_heading mb-1">
                        Start Time
                        <span className="danger">*</span>{" "}
                        {/* Show mandatory asterisk */}
                      </label>
                    </div>
                    <CustomTextField
                      placeholder="Start Time"
                      name="examStartTime"
                      id="examStartTime"
                      inputType="time"
                      showError={errorsStepOne?.examStartTime}
                      errorMessage={errorsStepOne?.examStartTime?.message}
                      register={registerStepOne}
                      additionalClasses="profile_edit"
                      showLabel={false}
                      setValue={setValuesStepOne}
                    

                    />
                  </div>
                  {/* End Time Field */}
                  <div className="col-md-6 ps-2">
                    <div className="d-flex justify-content-between">

                      <label htmlFor="startTime" className="login_heading mb-1">
                        End Time
                        <span className="danger">*</span>{" "}
                        {/* Show mandatory asterisk */}
                      </label>
                    </div>
                    <CustomTextField
                      placeholder="End Time"
                      name="examEndTime"
                      id="examEndTime"
                      inputType="time"
                      showError={errorsStepOne?.examEndTime}
                      errorMessage={errorsStepOne?.examEndTime?.message}
                      register={registerStepOne}
                      additionalClasses="profile_edit"
                      showLabel={false}
                      setValue={setValuesStepOne}
                     
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Duration in Mins"
                  placeholder="Duration in Mins"
                  name="durationInMinutes"
                  id="durationInMinutes"
                  inputType={InputType.number}
                  // showError={errorsStepOne?.durationInMinutes}
                  // errorMessage={errorsStepOne?.durationInMinutes?.message}
                  register={registerStepOne}
                  additionalClasses="profile_edit"
                  setValue={setValuesStepOne}
                  disabled={true}
                />
              </div>

                <div className="col-md-6 d-flex flex-column gap-2  my-2 gap-3 ">

              <h3 className="fw-500 fs-14  mb-0">Enable Negative Marking <span className="text-danger">*</span></h3>
              <label
                className="switch"
              >
                <input
                  type="checkbox"
                  checked={negativeMarking}
                  onChange={() =>{ setNegativeMarking(!negativeMarking)}}
                />
                <span className="slider round"></span>
              </label>
            </div>
              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={"Next Step"}
                  icon={SvgImages.right_arrow}
                  onClick={handleSubmitStepOne(saveStepOneData)}
                />
              </div>
            </div>
          </form>
        ) : null}

        {currentStep === 2 ? (
          <form onSubmit={handleSubmitStepTwo(savestepTwoData)}>
            <div className="row profile_inputs w-100">
              <div className="col-md-12">
                <div className="Highlightedsections px-3 py-4 m-0">
                  {additionalInputs.map((value, index) => (
                    <div key={index} className="row m-0 p-0">
                      <div className="col-md-6">
                        <CustomDropDown
                          labelTitle="Select Subject"
                          placeholder="Select"
                          name={value.name}
                          id={value.name}
                          additionalClasses="profile_edit"
                          resetValue={resetSubject}
                          setResetValue={setResetSubject}
                          inputType={InputType.text}
                          showError={errorsStepTwo[value.name]}
                          errorMessage={errorsStepTwo[value.name]?.message}
                          register={registerStepTwo}
                          showMandatory={true}
                          setValue={setValuesStepTwo}
                          labelClass="customtextcolorlabel"
                          options={subjects
                            ?.filter(
                              (e) =>
                                additionalInputs.findIndex(
                                  (data) =>
                                    getValuesStepTwo(data.name) === e._id
                                ) === -1
                            )
                            .map((e) => {
                              return { value: e._id, label: e.subject_name };
                            })}
                          defaultOption={() => {
                            const subject =
                              bharatSatExam?.subjectData &&
                                bharatSatExam.subjectData[index]  // Remove the >= index - 1 condition
                                ? bharatSatExam.subjectData[index]
                                : null;

                            if (!subject) return null;

                            return {
                              value: subject.subject?._id || subject.subjectId, // Handle both possible structures
                              label: subject.subject?.subject_name || subject.subjectName || "Select Subject"
                            };
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <CustomTextField
                          labelTitle="Total No. of Questions from Question Bank"
                          placeholder="Total No. of Questions from Question Bank"
                          name={value.value}
                          id={value.value}
                          inputType={InputType.number}
                          showError={errorsStepTwo[value.value]}
                          errorMessage={errorsStepTwo[value.value]?.message}
                          register={registerStepTwo}
                          setValue={setValuesStepTwo}
                          additionalClasses="profile_edit"
                          labelClass="customtextcolorlabel"
                          showMandatory={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <CustomTextField
                          labelTitle="Total Number of Questions from Bharat SAT Question Bank"
                          placeholder="Total Number of Questions from Bharat SAT Question Bank"
                          name={value.bharatSatValue}
                          id={value.bharatSatValue}
                          inputType={InputType.number}
                          showError={errorsStepTwo[value.bharatSatValue]}
                          errorMessage={
                            errorsStepTwo[value.bharatSatValue]?.message
                          }
                          register={registerStepTwo}
                          setValue={setValuesStepTwo}
                          additionalClasses="profile_edit"
                          labelClass="customtextcolorlabel"
                          showMandatory={true}
                        />
                      </div>
                    </div>
                  ))}
                  <div className="d-flex justify-content-between px-3 align-items-center">
                    <div
                      className="d-flex align-items-center gap-2 profile"
                      onClick={handleAddMore}
                    >
                      <Image src={SvgImages.addbutton} />
                      <h3 className="add_more mb-0 ">Add More</h3>
                    </div>

                    {(deleteInput || bharatSatExam) &&
                      additionalInputs.length > 1 && (
                        <div
                          className="d-flex align-items-center gap-2 text-danger  profile"
                          onClick={() =>
                            handleDelete(additionalInputs.length - 1)
                          }
                        >
                          <Image
                            src={SvgImages.deleteIcon}
                            style={ImageFilters.red}
                            alt="Delete Icon"
                          />
                          <h3 className="fw-500 fs-14 mb-0 ">Delete</h3>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end mt-5">
              <ButtonWithIcon
                text={bharatSatExam.bharatSatExamId ? "Update" : "Submit"}
                icon={SvgImages.tick_mark}
                onClick={handleSubmitStepTwo(savestepTwoData)}
              />
            </div>
          </form>
        ) : null}

        {currentStep === 3 ? (
          <div className="d-flex flex-column align-items-center justify-content-center mt-4">
            <Image
              src={SvgImages.StudyMaterialAddedSuccess}
              style={{ height: 250 }}
            />
            <h1 className="primary fs-20 fw-600 mb-0">Well Done!</h1>
            <h3 className="black fs-14 fw-400 mb-0 mt-1">
              You have successfully create exam
            </h3>

            <div className="d-flex justify-content-between align-items-center w-100 mt-5">
              <button
                className="back_login m-0 cursor-pointer"
                onClick={() => setCurrentStep(2)}
              >
                <Image src={SvgImages.back_arrow_login} className="m-0" />
                Back
              </button>
              <div className="select-btn">
                <ButtonWithIcon
                  text={"Create Bharat SAT Exam"}
                  icon={SvgImages.plus}
                  onClick={() => {
                    setbharatSatExam(null);
                    navigate(RoutesPath.addexam, { state: null });
                    window.location.reload();
                  }}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AddBharatSetExam;
